import React from "react";

export default function BrokerLogo({ broker, size = "md", className = "" }) {
  const box =
    size === "lg"
      ? "h-16 w-16 md:h-[4.5rem] md:w-[4.5rem]"
      : "h-14 w-14";
  const fit = broker.fit === "cover" ? "object-cover" : "object-contain";
  const pad = broker.bleed || broker.fit === "cover" ? "p-0" : "p-2";

  return (
    <span
      className={[
        "inline-flex shrink-0 items-center justify-center overflow-hidden rounded-2xl bg-white ring-1 ring-ink/8",
        box,
        pad,
        className,
      ].join(" ")}
    >
      <img
        src={broker.logo}
        alt=""
        className={["h-full w-full", fit].join(" ")}
        loading="lazy"
        decoding="async"
      />
    </span>
  );
}
